import * as React from 'react';
import { Reducer } from './Reducer';
import { createControllerView } from 'strikejs-react';
import { SplashScreen } from '../../pages/Splashscreen/Splashscreen';
import { AppProps, inAppState, WINDOW_VIEWS, inAppInitialState, AppInitState } from './StateAndProps';
import { ACTIONS } from './Actions';
import { SocialButtons } from '../../components/ui/SocialButtons/SocialButtons';
import { DialogProvider } from '../../components/ui/Dialog/DialogProvider';
import { SHOW_EMBED_DIALOG } from '../../components/ui/Dialog/Utils';
import { RES_URL, IS_MOBILE, IS_EMBED } from '../../config';
import { MainPage } from '../../pages/MainPage/MainPage';
import { LANG } from '../../constants';


export const STATE_KEY = 'app';

class AppController extends React.Component<AppProps, inAppState>{
    DP: DialogProvider;
    copySection: HTMLDivElement;
    
    constructor(props) {
        super(props);
        this.state = inAppInitialState;
        this.DP = new DialogProvider();
    }

    componentDidMount() {
        let DS = this.props.dataService;
        if (DS.isDataLoaded) {
            this.props.store.dispatch(ACTIONS.DATA_LOADED(DS.getData()));
            if(this.props.routeParams.route === "/embedCode"){
                SHOW_EMBED_DIALOG(this.props.data.locale);
            }
        } else {
            DS.load().then((e) => {
                this.props.store.dispatch(ACTIONS.DATA_LOADED(e))
                if(this.props.routeParams.route === "/embedCode"){
                    SHOW_EMBED_DIALOG(this.props.data.locale);
                }
            })
        }
    }

    hideSplashScreen = () => {
        this.setState({ currentView: WINDOW_VIEWS.CONTENT });
    }

    getCopySectionHeight = ():number => {
        if(this.copySection) {
            return this.copySection.getBoundingClientRect().height;
        }
    }

    setImgSectionHeight = ():React.CSSProperties => {
        const isLandscape = IS_MOBILE && (window.innerHeight < window.innerWidth);

        if(isLandscape) {
            return { height: `${this.getCopySectionHeight()}px` }
        }
    }

    render() {
        let state = this.state,
            props = this.props,
            locale = this.props.data.locale;

        return (
            <div className={`app-container ${LANG}`}>
                <div className="app__img-preloader">
                    {
                        images.map((val, i) => {
                            return (
                                <div className={`preload-img img-${i}`}
                                    style={{ backgroundImage: `url(${RES_URL}img/${IS_EMBED ? "embed/" : ""}${val}.jpg)` }}
                                    key={`${i}-${val}`}
                                ></div>
                            )
                        })
                    }
                </div>
                {
                    this.props.dataService.isDataLoaded &&
                    (<SplashScreen
                        locale={locale}
                        visible={state.currentView === WINDOW_VIEWS.SPLASH}>
                            <div className="splash__copy-section" ref={e => this.copySection = e}>
                                <div className="splash__lang-btns-container">
                                    <div className={`splash__lang-btn de ${LANG === "de" ? "selected" : ""}`}>
                                        <a href={`https://www.lenstore.de/vc/historisches-berlin/${IS_EMBED ? "#/embed" : ""}`}>                                    
                                            <p>de</p>
                                        </a>
                                    </div>
                                    <div className={`splash__lang-btn en ${LANG === "en" ? "selected" : ""}`}>
                                        <a href={`https://www.lenstore.de/vc/historisches-berlin/en/${IS_EMBED ? "#/embed" : ""}`}>                                    
                                            <p>en</p>
                                        </a>
                                    </div>
                                </div>
                                <div className="splash__copy">
                                    { locale.splashIntro.map((val, i) => <p key={i}>{val}</p>) }
                                </div>
                                <div className="splash__explore-btn"
                                    onClick={this.hideSplashScreen}
                                >
                                    <p>{locale.exploreButton}</p>
                                    <div className="splash__arrow">
                                        <img src={`${RES_URL}img/icons/arrow.svg`} alt="arrow icon"/>
                                    </div>
                                </div>
                            </div>
                            <div className="splash__img-section" style={this.setImgSectionHeight()} >                            
                                <div className="splash__img-container">
                                    <div className="splash__campaign-logo-backdrop">
                                        <div className={`splash__campaign-logo ${LANG}`}>
                                            <img src={`${RES_URL}img/${LANG}/campaign-logo.svg`} 
                                                alt={locale.campaignName}
                                                className="campaign-logo"
                                            />
                                        </div>
                                    </div>
                                    <img src={`${RES_URL}img/_mobile/splash-portrait.jpg`} alt="" className="splash__img"/>
                                </div>
                            </div>
                            <div className="splash__footer">
                                <div className="splash__social">
                                    <SocialButtons
                                        locale={locale}
                                    >
                                    </SocialButtons>
                                </div>
                                <div className={`splash__client-logo de`}>
                                    <a href={locale.clientUrl} target="_blank" className="hide-on-embed">
                                        <img src={`${RES_URL}img/${LANG}/client-logo.svg`} 
                                             alt={locale.clientTitle} 
                                             className="client-logo"
                                        />
                                    </a>
                                </div>
                            </div>
                    </SplashScreen>)
                }
                {
                    props.dataService.isDataLoaded && state.currentView === 1 ? (
                        <MainPage
                            locale={locale}
                            dataset={props.data.dataset}
                        >
                        </MainPage>
                    )
                    : null
                }
            </div>
        );
    }
};

const images: string[] = [
    "new/1903-gendarmenmarkt",
    "new/1905-dennewitzstrasse",
    "new/1926-hotel-adlon",
    "new/1928-berliner-dom",
    "new/1928-brandenburger",
    "new/1929-bundestag-reichstag",
    "new/1929-siegessaeule",
    "new/1945-potsdamer-platz",
    "new/1955-cafe-kranzler",
    "new/1970-fernsehturm",
    "new/1989-berliner-mauer",

    "old/1903-gendarmenmarkt",
    "old/1905-dennewitzstrasse",
    "old/1926-hotel-adlon",
    "old/1928-berliner-dom",
    "old/1928-brandenburger",
    "old/1929-bundestag-reichstag",
    "old/1929-siegessaeule",
    "old/1945-potsdamer-platz",
    "old/1955-cafe-kranzler",
    "old/1970-fernsehturm",
    "old/1989-berliner-mauer"
];

export const App = createControllerView({
    reducer: Reducer,
    propsToPropagate: ['dataService'],
    initialState: AppInitState,
    stateKey: STATE_KEY,
    component: (function () {
        return AppController
    }()),
}); 


// WEBPACK FOOTER //
// ./src/controllers/App/App.tsx